export default {
  state: {
    d2d: {
      enabled: true,
      pickup: {},
      pickupAirport: {},
      pickupDetails: {
        pickupTime: {
          leg1: '',
          leg2: ''
        },
        timezone: {
          leg1: '',
          leg2: ''
        },
        eta: '',
        quote: {}
      },
      dropoff: {},
      dropoffAirport: {},
      dropoffDetails: {
        pickupTime: {
          leg1: '',
          leg2: ''
        },
        timezone: {
          leg1: '',
          leg2: ''
        },
        eta: '',
        quote: {}
      },
      departure: {
        date: '',
        return: '',
        isReturning: true,
        show: false
      },
      travellers: {
        show: false,
        total: 1,
        adult: 1,
        children: 0,
        infants: 0,
        info: {
          adult: [],
          children: [],
          infants: []
        },
        forSomeoneElse: false
      },
      airlines: {
        selectedCabin: '',
        flights: [],
        Economy: [],
        PremiumEconomy: [],
        Business: [],
        PremiumBusiness: [],
        First: [],
        filtered: {
          Economy: [],
          PremiumEconomy: [],
          Business: [],
          PremiumBusiness: [],
          First: []
        },
        list: [],
        loading: [],
        unique: {
          Economy: [],
          PremiumEconomy: [],
          Business: [],
          PremiumBusiness: [],
          First: []
        }
      },
      airlinesReturn: {
        enabled: false,
        active: 'leg1',
        selectedCabin: '',
        Economy: [],
        PremiumEconomy: [],
        Business: [],
        PremiumBusiness: [],
        First: [],
        filtered: {
          Economy: [],
          PremiumEconomy: [],
          Business: [],
          PremiumBusiness: [],
          First: []
        },
        unique: {
          Economy: [],
          PremiumEconomy: [],
          Business: [],
          PremiumBusiness: [],
          First: []
        },
        token: {
          leg1: '',
          leg2: ''
        },
        pickupAirport: {},
        dropoffAirport: {}
      },
      filter: {
        loading: false,
        airlines: [],
        airlinesReturn: [],
        minPrice: 0,
        maxPrice: 40000,
        minPriceReturn: 0,
        maxPriceReturn: 40000,
        refundableOnly: false,
        count: {
          airlines: {
            Economy: {},
            PremiumEconomy: {},
            Business: {},
            PremiumBusiness: {},
            First: {}
          },
          flightStop: {
            none: 0,
            '1stop': 0,
            '2stop': 0,
            '3stop': 0
          },
          departure: {
            earlyMorning: 0,
            morning: 0,
            midDay: 0,
            evening: 0,
            earlyMorningReturn: 0,
            morningReturn: 0,
            midDayReturn: 0,
            eveningReturn: 0
          },
          arrival: {
            earlyMorning: 0,
            morning: 0,
            midDay: 0,
            evening: 0,
            earlyMorningReturn: 0,
            morningReturn: 0,
            midDayReturn: 0,
            eveningReturn: 0
          }
        }
      },
      airports: [],
      nearByAirports: {
        pickup: [],
        dropoff: []
      },
      extras: {
        selected: 'DEL-BOM'
      },
      seats: {
        selected: [],
        list: {}
      },
      meals: {
        selected: [],
        preference: [],
        list: {}
      },
      fetch: [],
      selected: {
        leg1: {},
        leg2: {}
      },
      landQuote: {
        leg1Depart: {},
        leg1Arrive: {},
        leg2Depart: {},
        leg2Arrive: {}
      },
      lastToken: '',
      lastToken2: '',
      finalPrice: {},
      finalPrice2: {},
      settings: {
        // timeBuffer: 10080,
        timeBuffer: 0,
        markUpPercent: 0.1,
        arrivalBufferDomestic: 30,
        arrivalBufferInternational: 45,
        departureBufferDomestic: 90,
        departureBufferInternational: 150,
        nearByAirportMilesLimit: 50,
        groundLeg1Discount: 0,
        groundLeg2Discount: 0,
        groundLeg3Discount: 0,
        groundLeg4Discount: 0,
        requirePhone: 0,
        sessionTimeout: 900,
        sessionShowWarning: 180
      },
      bookingRef: {
        // leg1: '',
        // leg2: '',
        // pnr: '',
        // pnr2: '',
        // d2dIdLeg1: '',
        // d2dIdLeg2: '',
        leg1: {
          bookingId: '',
          pnr: '',
          d2dId: ''
        },
        leg2: {
          bookingId: '',
          pnr: '',
          d2dId: ''
        }
      },
      includedLandTranspo: [],
      totalDiscount: 0,
      flightPending: false,
      lastSelectedFlight: {
        leg1: {},
        leg2: {}
      },
      applyFilter: {
        Economy: false,
        PremiumEconomy: false,
        Business: false,
        PremiumBusiness: false,
        First: false
      },
      showFrontModal: false
    }
  },
  mutations: {
    setD2DData (state, data) {
      for (let field in data) {
        state.d2d[field] = data[field]
      }
    },
    setD2DPickupDetails (state, data) {
      for (let field in data) {
        state.d2d.pickupDetails[field] = data[field]
      }
    },
    setD2DDropoffDetails (state, data) {
      for (let field in data) {
        state.d2d.dropoffDetails[field] = data[field]
      }
    },
    setD2DLandPickupTime (state, data) {
      state.d2d[data.type].pickupTime[data.leg] = data.val
    },
    setD2DLandTimezone (state, data) {
      state.d2d[data.type].timezone[data.leg] = data.val
    },
    setD2dDeparture (state, data) {
      for (let field in data) {
        state.d2d.departure[field] = data[field]
      }
    },
    setD2dTravellers (state, data) {
      for (let field in data) {
        state.d2d.travellers[field] = data[field]
      }
    },
    addD2DAirlineFlights (state, data) {
      state.d2d.airlines[data.field].push(data.value)
    },
    setD2dAirlines (state, data) {
      for (let field in data) {
        state.d2d.airlines[field] = data[field]
      }
    },
    setD2dAirlinesUnique (state, data) {
      for (let field in data) {
        state.d2d.airlines.unique[field] = data[field]
      }
    },
    unavailableFlight (state, data) {
      let i = state.d2d.airlines[data.class].findIndex(x => x.token === data.token)
      if (i > -1) {
        state.d2d.airlines[data.class][i].available = false
      }

      i = state.d2d.airlines.filtered[data.class].findIndex(x => x.token === data.token)
      if (i > -1) {
        state.d2d.airlines.filtered[data.class][i].available = false
      }
    },
    addD2DAirlineFilter (state, data) {
      for (let field in data) {
        state.d2d.airlines.filtered[field] = data[field]
      }
    },
    toggleD2DAirlineLoading (state, value) {
      let i = state.d2d.airlines.loading.indexOf(value)
      if (i > -1) state.d2d.airlines.loading.splice(i, 1)
      else state.d2d.airlines.loading.push(value)
    },
    setD2dAirlinesReturn (state, data) {
      for (let field in data) {
        state.d2d.airlinesReturn[field] = data[field]
      }
    },
    addD2DAirlineReturnFlights (state, data) {
      state.d2d.airlinesReturn[data.field].push(data.value)
    },
    setD2dAirlinesReturnUnique (state, data) {
      for (let field in data) {
        state.d2d.airlinesReturn.unique[field] = data[field]
      }
    },
    setD2dAirlinesReturnFilter (state, data) {
      for (let field in data) {
        state.d2d.airlinesReturn.filtered[field] = data[field]
      }
    },
    setD2dAirlinesReturnToken (state, data) {
      for (let field in data) {
        state.d2d.airlinesReturn.token[field] = data[field]
      }
    },
    setD2dFilter (state, data) {
      for (let field in data) {
        state.d2d.filter[field] = data[field]
      }
    },
    setD2dFilterCount (state, data) {
      for (let field in data) {
        state.d2d.filter.count[field] = data[field]
      }
    },
    setD2dFilterCountAirlines (state, data) {
      for (let field in data) {
        state.d2d.filter.count.airlines[field] = data[field]
      }
    },
    setD2dExtras (state, data) {
      for (let field in data) {
        state.d2d.extras[field] = data[field]
      }
    },
    setD2dSeats (state, data) {
      for (let field in data) {
        state.d2d.seats[field] = data[field]
      }
    },
    setD2dMeals (state, data) {
      for (let field in data) {
        state.d2d.meals[field] = data[field]
      }
    },
    setD2dSelected (state, data) {
      for (let field in data) {
        state.d2d.selected[field] = data[field]
      }
    },
    setD2DLandQuote (state, data) {
      for (let field in data) {
        state.d2d.landQuote[field] = data[field]
      }
    },
    addTravellerInfo (state, data) {
      for (let field in data) {
        state.d2d.travellers.info[field] = data[field]
      }
    },
    clearTravellerInfo (state) {
      state.d2d.travellers.info = {
        adult: [],
        children: [],
        infants: []
      }
    },
    // setD2DBookingRef (state, data) {
    //   for (let field in data) {
    //     state.d2d.bookingRef[field] = data[field]
    //   }
    // },
    setD2DBookingRefData (state, data) {
      for (let field in data) {
        state.d2d.bookingRef[field] = data[field]
      }
    },
    setD2DNearyByAirports (state, data) {
      state.d2d.nearByAirports[data.field] = data.val
    },
    addD2DNearyByAirports (state, data) {
      state.d2d.nearByAirports[data.field].push(data.val)
    },
    toggleIncludedLandTranspo (state, val) {
      let i = state.d2d.includedLandTranspo.indexOf(val)
      if (i > -1) state.d2d.includedLandTranspo.splice(i, 1)
      else state.d2d.includedLandTranspo.push(val)
    },
    setLastSelectedFlightData (state, data) {
      for (let field in data) {
        state.d2d.lastSelectedFlight[field] = data[field]
      }
    },
    setD2DApplyFilter (state, data) {
      for (let field in data) {
        state.d2d.applyFilter[field] = data[field]
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/reservation/d2d.js